import { Delete } from '@mui/icons-material';
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { generateRandomLightColor } from "utils/methods/math";
import AddMoreCell from "../type/addMoreCell";
import WordSelectedType from "../type/wordSelectType";
import imageWithTextSelectType from "../type/imageWithTextSelectType";
import imageSelectType from "../type/imageSelectType";

const GridView = ({ grid, selectedType, setGrid,bingoSize }) => {
  const containerWidth = 100; // percentage
  const minCellWidth = 150; // minimum width in pixels
  const [editingCell, setEditingCell] = useState(null);
  const [gridContainerOffSet, setGridContainerOffset] = useState(0);
  const gridContainerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridContainerRef.current) {
        setGridContainerOffset(gridContainerRef.current.offsetWidth);
      }
    };
  
    if (gridContainerRef.current) {
      setGridContainerOffset(gridContainerRef.current.offsetWidth);
    }

    window.addEventListener('resize', handleResize);
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const typeComponentMap = {
    Word: WordSelectedType,
    Image: imageWithTextSelectType,
    VocabWord: WordSelectedType,
    VocabImage: imageWithTextSelectType,
    OnlyImage: imageSelectType
  };

  const getSelectedComponent = useCallback(() => {
    return typeComponentMap[selectedType] || WordSelectedType;
  }, [selectedType]);

  const SelectedTypeComponent = getSelectedComponent();

  const handleEditingCell = (index) => {
    setEditingCell(index);
  };

  const handleDeleteCell = (fitlerIndex) => {
    setGrid((prev) => prev.filter((_, index) => fitlerIndex !== index));
  };

  const handleAddMoreCell = () => {
    const data = [...grid];
    data.push({
      type: "",
      value: "",
      backgroundColor: generateRandomLightColor(),
      percant: 0,
      isCustom: true,
      cellSize: bingoSize
    });
    setGrid(data);
  };

  const handleUpdateCell = (updateIndex, updatedData) => {
    setGrid((prev) => {
      return prev.map((element, index) => {
        if (index === updateIndex) {
          const data = { ...element, ...updatedData };
          return data;
        }
        return element;
      });
    });
  };

  const getGridColumns = useCallback((itemCount) => {
    if (itemCount <= 2) {
      return itemCount;
    }
    return "auto-fit"; 
  }, []);

  

  return (
    <GridContainer
      className="grid-container"
      containerWidth={containerWidth}
      minCellWidth={minCellWidth}
      columns={getGridColumns(grid?.length || 0)}
      ref={gridContainerRef}
    >
      {grid?.map((element, index) => (
        <div className="relative">
          <SelectedTypeComponent
            key={index}
            currentIndex={index}
            element={element}
            selectedType={selectedType}
            editingCell={editingCell}
            handleEditingCell={handleEditingCell}
            handleUpdateCell={handleUpdateCell}
            totalCells={grid?.length}
            readOnly={false}
            gridContainerWidth={gridContainerOffSet}
          />
          {element?.isCustom && (
            <DeleteButton onClick={() => handleDeleteCell(index)}>
              <Delete color="secondary" />
            </DeleteButton>
          )}
        </div>
      ))}
      <AddMoreCell
        handleAddCell={handleAddMoreCell}
        selectedType={selectedType}
      />
    </GridContainer>
  );
};

export default memo(GridView);

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ minCellWidth, columns, itemCount }) =>
    columns === "auto-fit"
      ? `repeat(auto-fit, minmax(${minCellWidth}px, 1fr))`
      : `repeat(${columns}, ${minCellWidth}px)`};
  width: ${({ containerWidth }) => `${containerWidth}%`};
  border-radius: 4px;
  overflow: hidden;
  gap: 3px;
  justify-content: center; // Center the grid items
  margin: 0 auto; // Center the container itself
  ${({ itemCount }) => 
    itemCount <= 2 && `
      max-width: ${itemCount * 153}px; // 150px + 3px gap
    `}
`;

const DeleteButton = styled.span`
  position: absolute;
  cursor: pointer;
  top: 4px;
  right: 5px;
`;
